import styled, { css } from 'styled-components';
import media from '../../../styles/Media.styled';
import Popover from '@material-ui/core/Popover';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const UserProfileContainer = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    display: flex;
    width: 100%;
    font-family: AvenirNextWorld Demi;
    color: #ffffff;
    align-items: center;
    justify-content: ${isMobile ? 'left' : 'center'};
    flex-direction: ${isMobile ? 'row' : 'row-reverse'};
    height: 3.5rem;

    ${media.portraitDevice`
        ${({ isSideNavBar }) =>
            isSideNavBar &&
            css`
                justify-content: left;
                flex-direction: row;
            `}
    `}

    ${media.mobileDevice`
        margin: 13px;
        justify-content: left;
        flex-direction: row;
    `}
`;

export const DropDownButton = styled.div`
    background: transparent;
    width: 5px;
    height: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 15px;
    display: ${isMobile && 'none'};
    cursor: pointer;
    ${media.portraitDevice`
        ${({ isSideNavBar }) =>
            isSideNavBar &&
            css`
                display: none;
            `}
    `}

    ${media.mobileDevice`
        display: none;
    `}
`;

export const UserNameContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 14px;
    font-family: AvenirNextWorld Demi;
    line-height: ${isMobile ? 'normal' : '15px'};
    height: ${isMobile ? 'auto' : '35px'};
    text-align: ${isMobile && 'left'};

    &.username {
        padding-bottom: 0;
    }

    & .mail {
        line-height: 14px;
        padding-top: 0;
        font-family: AvenirNextWorld Regular;
        opacity: 0.5;
        font-size: 13px;
    }
    ${media.portraitDevice`
        ${({ isSideNavBar }) =>
            isSideNavBar &&
            css`
                text-align: left;
                margin: 0 0 0 10px;
            `}
    `}

    ${media.mobileDevice`
        height: auto;
        line-height: normal;
        justify-content: flex-start;
        & .mail  {
            opacity: 1;
            line-height: normal;
        }
    `}
`;
export const ProfilePopover = styled(Popover)`
    &.MuiPopover-root {
        z-index: 100000 !important;
    }
    & .MuiPaper-root {
        top: ${({ hasBanner }) =>
            hasBanner ? '120px !important' : '60px !important'};
    }

    ${media.mobileDevice`
        display:none;
        /* & .MuiPaper-root {
        top: 60px !important;
        right: 0px !important;
        left: 0px !important;
    } */
    `}
`;
export const ProfileInfoContainer = styled.div`
    width: 297px;
    /* height: 195px; */
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #f5f5f5;
    border-radius: 0px 0px 6px 6px;
    opacity: 1;
    ${media.mobileDevice`
        display:none;
    `}
`;
export const UserInfo = styled.div`
    margin: 15px 21px;
`;

export const SalesContainer = styled.div`
    /* height: 50px; */
    /* overflow-y: scroll; */
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #140f4b;
    word-break: ${(props) => props.wordBreak};
`;

export const EmployeeRoleContainer = styled.div`
    margin-bottom: 16px;
    margin-top: 13px;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #140f4b;
    text-align: left;
`;
export const MyProfileContainer = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    cursor: pointer;
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    text-align: left;
    // margin-bottom: 36px;
`;

export const LogoutButtonContainer = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    font-size: 14px;
    font-family: AvenirNextWorld Demi;
    text-align: left;
`;

export const LogOutContainer = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    margin-top:10px;
`;

export const LogoutText = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #140f4b;
`;
export const LogOutIconContainer = styled.div`
    margin: 0;
    padding: 0;
    width: 2rem;
    height: 2rem;
`;

export const LogOutIconImage = styled.img.attrs((props) => ({
    src: props.defaultImg,
    alt: props.name,
}))``;

export const ExtraContainer = styled.span`
    font-family: AvenirNextWorld Demi;
    color: #1010eb;
    margin: 0 5px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    line-height: 25px;
    cursor: pointer;
`;
